var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBulkUpload = function SvgBulkUpload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9102 0H37.4113C38.8309 0 40 1.1691 40 2.58873V17.8706C40 19.2902 38.8309 20.4593 37.4113 20.4593H25.3862L20.7933 25.0522V20.4593H3.00627C1.58664 20.4593 0.417542 19.2902 0.417542 17.8706V2.58873C0.417542 1.1691 1.58664 0 3.00627 0H22.9645H36.9102Z",
    fill: "#03A38A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.048 37.9958H35.3236C36.3257 37.9958 37.3278 37.1608 37.5783 36.2422L39.9165 27.4739C40.167 26.4718 39.5825 25.7202 38.5804 25.7202H26.3883C25.3862 25.7202 24.3841 26.5553 24.1336 27.4739L21.7954 36.2422C21.4614 37.1608 22.0459 37.9958 23.048 37.9958Z",
    fill: "#06594C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8643 20.2923C14.8643 22.881 12.7766 24.9687 10.1879 24.9687C7.59916 24.9687 5.51147 22.881 5.51147 20.2923C5.51147 17.7036 7.59916 15.6159 10.1879 15.6159C12.7766 15.6159 14.8643 17.7036 14.8643 20.2923Z",
    fill: "#03CFAE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10021 39.666L11.6075 32.8184L15.8664 37.9123H25.1357V36.0751L18.5386 34.9895L12.9436 27.5574C12.9436 27.5574 7.76618 23.215 5.51148 27.3069L0 39.666H8.10021Z",
    fill: "#03CFAE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7495 37.6618H12.7766V39.9165H39.7495V37.6618Z",
    fill: "#03B599"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76825 6.17953H31.7328",
    stroke: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76825 9.93738H31.7328",
    stroke: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76825 13.6117H25.9708",
    stroke: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBulkUpload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bulkUpload.d9401741.svg";
export { ForwardRef as ReactComponent };